export const PROSPECTS = 'Prospects';